<template>
    <v-dialog
    v-model="profileToggle"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    scrollable
    >
        <v-card tile>
            <v-toolbar
            flat
            dark
            color="primary"
            >
            <v-btn
                icon
                dark
                @click="profileToggle = false"
            >
                <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>{{ 'Hello, ' + user.name }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <v-btn
                dark
                text
                @click="profileToggle = false"
                >
                Close
                </v-btn>
            </v-toolbar-items>
            </v-toolbar>
            <v-card-text>
            <v-list
                three-line
                subheader
            >
                <v-subheader>Account Settings</v-subheader>
                <v-list-item @click.prevent="passwordShow = !passwordShow">
                    <v-list-item-content>
                        <v-list-item-title>Password</v-list-item-title>
                        <v-list-item-subtitle>Change Your Password</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
            <v-divider></v-divider>
            <Password :show="passwordShow" @update-password="passPopToggle"/>
            </v-card-text>
            <div style="flex: 1 1 auto;"></div>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import Password from './Password.vue'

export default {
    data () {
        return {
            passwordShow: false,
            show2: false,
        }
    },
    components: {
        Password
    },
    computed: {
        ...mapGetters({
            dialog: 'menu/profileDialog',
            user: 'auth/user'
        }),
        profileToggle: {
            get() {
                return this.dialog
            },
            set(newValue) {
                this.$store.commit('menu/SET_PROFILE_DIALOG', newValue)
            }
        },
    },
    methods: {
        passPopToggle(val) {
            this.passwordShow = val
        }
    }
}
</script>